export default "__VITE_ASSET__4d3b18a4__"